import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useCartIntermediateContext } from '../../../hooks/useCartIntermediateContext'

export const CartIntermediateProductInfoQuantity: FC = () => {
  const { quantity } = useCartIntermediateContext()

  return (
    <div
      className="text-s text-dark-primary-strong"
      data-qa-id="cart-intermediate-product-quantity-select"
    >
      <FormattedMessage
        id="general.label.quantityN"
        values={{ amount: quantity }}
      />
    </div>
  )
}
